import { useCallback } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { useConfigContext } from 'config/ui/ConfigContext'

import { getOpenDockWarehouseAvailability } from '../../use-cases/getOpenDockWarehouseAvailability'

export function useGetOpenDockWarehouseAvailability() {
  const { call, result, status, error } = useAsync(getOpenDockWarehouseAvailability)
  const abortController = useAbortController()
  const configs = useConfigContext()
  const enableShowAllDocksAvailability = configs.enableShowAllDocksAvailability.toBoolean()

  const fetchOpenDockWarehouseAvailability = useCallback(
    (
      shipmentUUID: string,
      stopIndex: number,
      {
        loadTypeId,
        dockId,
        appointmentDate,
        facilityTimezone,
      }: { loadTypeId: string; dockId: string; appointmentDate: string; facilityTimezone?: string }
    ) => {
      return call({
        enableShowAllDocksAvailability,
        shipmentUUID,
        stopIndex,
        params: { loadTypeId, dockId, appointmentDate, facilityTimezone },
        config: abortController,
      })
    },
    [abortController, call, enableShowAllDocksAvailability]
  )

  return {
    warehouseAvailability: result,
    status,
    error,
    fetchOpenDockWarehouseAvailability,
  }
}
